<template lang="pug">
    section#conteudo
        article.conteudo#apresentacao
            h2 {{ curso.nome_curso }}

            section.portaria(v-if="curso.texto_port_mec")
                a(:href="curso.link_port_mec", v-if="curso.link_port_mec", target="_blank", v-html="curso.texto_port_mec", title="Registro MEC")
                p(v-html="curso.texto_port_mec", v-else)

            section
                div(v-if="curso.has_ap_apresentacao")
                    p(v-html="curso.ap_apresentacao")
                div(v-if="curso.has_ap_onde_trabalhar")
                    h3 Onde Trabalhar
                    p(v-html="curso.ap_onde_trabalhar")
                div(v-if="curso.has_ap_o_curso")
                    h3 O Curso
                    p(v-html="curso.ap_o_curso")
                div(v-if="curso.has_ap_previsao_carreira")
                    h3 Previsão de Carreira
                    p(v-html="curso.ap_previsao_carreira")
                div(v-if="curso.has_ap_achou_asua_cara")
                    h3 Achou {{ curso.nome_curso }} a sua cara?
                    p(v-html="curso.ap_achou_asua_cara")
                div(v-if="curso.has_ap_espec_hardware")
                    h3 Especificações de Hardware e Software recomendadas para Cursos de Tecnologia da UniFAEL
                    p(v-html="curso.ap_espec_hardware")
                div.videoEmbed(v-if="curso.has_video")
                    iframe(:src="curso.video", frameborder="0", allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture", allowfullscreen)

        article.conteudo#calendario(v-if="curso.has_calendario_academico")
            h2 Calendário
            section
                p
                    a(:href="curso.calendario_academico", target="_blank", title="Visualizar calendário acadêmico") Clique aqui
                    |  para visualizar o calendário acadêmico.

        article.conteudo#corpo(v-if="curso.has_corpo_docente")
            h2 Corpo Docente
            section
                p
                    a(:href="curso.corpo_docente", target="_blank", title="Visualizar corpo docente") Clique aqui
                    |  para visualizar o corpo docente.

        article.conteudo#parceria(v-if="curso.has_parceiro")
            h2 Parceria
            section(v-html="curso.parceiro.conteudo")

        article.conteudo(v-for="item in itensConteudo", :id="item.id")
            h2 {{ item.titulo }}
            section(v-html="curso[item.conteudo]")
</template>

<script>
export default {
    name: "section-conteudo",
    props: {
        curso_raw: {
            type: Object,
            required: true
        },
        itensMenu: {
            type: Array,
            required: true
        }
    },
    data() {
        return {
            conteudoAtivo: '#apresentacao',
            subtab: false
        }
    },
    computed: {
        itensConteudo() {
            return this.itensMenu.filter(item => item.hash != '#calendario' && item.hash != '#corpo' && item.hash != '#parceria' && item.hash != '#apresentacao')
        },
        curso() {
            if (!this.curso_raw)
                return {}
            let curso = Object.assign({}, this.curso_raw)
            this.itensMenu.forEach(item => {
                if (item.conteudo.includes('metodologia')) {
                    curso['metodologia'] = this.curso_raw['metodologia']
                        .replace(/[\r\n]/gim, ' ')
                        .replace(/\*.*font-style:\snormal;\s+}\s+/gim, '')
                }
            })
            return curso
        },
    },
    methods: {
        toggleConteudo(hash) {
            this.conteudoAtivo = hash
        },
        showMore() {
            this.subtab = !this.subtab
        }
    },
}
</script>

<style lang="stylus" scoped src="./Conteudo.styl"></style>
